import { Foundation } from '@models';

export interface SuggestedFoundationsResult {
  suggestedFoundations: Foundation[];
}
